// src/components/About.js
import React from 'react';
import './About.css';
import profileImg from '../Assets/aboutUs.jpg'; // replace with your own image

const About = () => {
    return (
        <section className="about-section" id="about">
            <h1>About <span>Us</span></h1>
            <div className="about-wrapper">
                <div className="about-img-container">
                    <div className="about-img-glass">
                        <img src={profileImg} alt="About Us" className="about-img" />
                    </div>
                </div>

                <div className="about-content">
                    <h2 className="about-heading">
                        Meet the <span>Visionaries</span>
                    </h2>
                    <p className="about-description">
                        We're a collective of creative minds building intuitive and robust digital experiences.
                        Whether it's a mobile app or web platform, we craft meaningful tech that empowers users.
                    </p>
                    <a href="#contact" className="about-cta">
                        Let's Connect
                    </a>
                </div>
            </div>
        </section>
    );
};

export default About;
